<template>
    <div>
        <stats :headline="headline">
            <stat :name="$t('shared.modals.adjust_quantity_modal.adjust_overview.total_plan')" :value="quantity"/>
            <stat :name="$t('shared.modals.adjust_quantity_modal.adjust_overview.sold')" :value="sold"/>
            <stat v-if="showPending" :name="$t('shared.modals.adjust_quantity_modal.adjust_overview.pending')" :value="pending"/>
            <stat :name="$t('shared.modals.adjust_quantity_modal.adjust_overview.available')" :value="available"/>
        </stats>
    </div>
</template>

<script>

import { Link } from '@inertiajs/vue2';
import Stats from "../Stats";
import Stat from "../Stat";

export default {
    components: {
        Link,
        Stats,
        Stat
    },
    props: {
        headline: String,
        quantity: Number,
        sold: Number,
        available: Number,
        pending: Number,
        showPending:  {
            type: Boolean,
            default: false
        },
        boldHeadline: {
            type: Boolean,
            default: false
        }
    }
}
</script>
